import React, { useEffect, useRef, useState } from 'react';
import toast from "react-hot-toast";
import { Link, useNavigate ,useParams} from "react-router-dom";
//  import axiosInstance, { adminurl } from "../../axiosInstance";
import getDecryptData from "../../../helpers/getDecryptData";
import axiosInstance, { weburl } from "../../../axiosInstance";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import { useThemeContext } from "../../../fetchdata/ThemeContext";
import Select from "react-select";
import GooglePlaceSelect from "../../components/GooglePlaceSelect";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { triggerChooseimg } from "../../components/ChooseImg";
import Gallery from '../../components/Gallery';
import KeyFeatures from '../../components/sections/KeyFeatures';
import OfferSection from '../../components/sections/OfferSection';
import FAQSection from '../../components/sections/FAQSection';
import LoadingScreen from '../../components/LoadingScreen';

const ProfileEdit = () => {
  const { id } = useParams();

    const [featuresData, setFeaturesData] = useState([]);
    const [faqData, setFaqData] = useState([]);
        const [offersData, setOffersData] = useState([]);

   
  const [imageDivs, setImageDivs] = useState([]);


    const addImageDiv = () => {
      const newImageDiv = (
        <div key={imageDivs.length} className={`col-md-3 col-6`}>
          <div className={`input-group imageupload-bx mb-3`}>
            <img
              className="image-preview"
              src="/assets/images/placeholder.png"
              alt="Preview"
              id={`imageinput${imageDivs.length}`}
              data-bs-toggle="modal"
              data-bs-target="#modal-default"
            />
            <input
              type="hidden"
              className="form-control imageopen"
              id={`imageproduct${imageDivs.length}`}
              name="productImg[]"
              value="/assets/images/placeholder.png"
            />
          </div>
          <button
            className="btn btn-danger d-block m-auto"
            onClick={removeImageDiv}
          >
            Delete
          </button>
          <br />
        </div>
      );
  
      const updatedImageDivs = [...imageDivs, newImageDiv];
      setImageDivs(updatedImageDivs);
      setTimeout(function () {
        triggerChooseimg();
      }, 1);
    };
  
    const removeImageDiv = (event) => {
      const button = event.target;
      const parentDiv = button.parentNode; // Accessing the parent div
      parentDiv.remove(); // Remove the parent div
    };
  
 
  
 
   const {dataAuth,getAuth} = useThemeContext();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
   const [data2, setDataNew] = useState([]);
 
      const [filterInputs, setFilterInputs] = React.useState({
     location: "",
     placeId: "",
   });


  const [inputs, setInputs] = useState({
    type: "1",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    // profile: null, // Changed to null to match file type
    // DLfile: null,
    // AadhaarFront: null,
    // AadhaarBack: null,
    // PoliceVerification: null,
    // PassPort: null,
    // Electricity: null,
    // WaterBill: null,
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const removeCoverage = (cityToRemove) => {
    setInputs((prev) => ({
      ...prev,
      coverage: prev.coverage.filter((c) => c !== cityToRemove),
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
    }
    // Capitalize text for the 'username' field

    if (name === "coverage") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.coverage) ? inputs.coverage : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          coverage: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
    

 // Capitalize text for the 'username' field
 if (name === "state") {
  const selectedState = data.find((state) => state._id === newValue);
  if (selectedState) {
    setFilteredCities(selectedState.cities);
    setInputs((prevData) => ({
      ...prevData,
      statename: selectedState.name,
      city: "",
    }));
  }
  console.log("selectedState", selectedState, newValue, data);
}

    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [showPassword, setShowPassword] = useState(false);


    const handleDescriptionChange = (value) => {
    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      about: value,
    }));
  };


  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
 

        const imageInputs = document.querySelectorAll(
      '#imageContainer input[type="hidden"]'
    );
    const inputValues = Array.from(imageInputs).map((input) => input.value);


    if(!inputs.type){
      toast.error("please select user type");
         return;
    }

    if(inputs.type === "4" && !inputs.empType){
      toast.error("please select empployee type");
         return;
    }

    setSubmitLoading(false);
    console.log(inputs);

    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "state", message: "Please enter State" },
      { name: "city", message: "Please enter State" },
      { name: "pincode", message: "Please enter pincode" },
      // { name: "coverage", message: "Please Select Coverage Area" },
      
      // Fields below are conditionally required based on inputs.type
      // ...(inputs.type !== "3"
      //   ? [
      //       { name: "Gender", message: "Please enter Gender" },
      //       { name: "DOB", message: "Please enter DOB" },
      //     ]
      //   : []),
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(true);
        return;
      }
    }

    if (inputs.password !== inputs.confirm_password) {
      toast.error("Password does not match");
      setSubmitLoading(true);
      return;
    }

    // if(form.address === '' || form.address === null){
    //   toast.error('Please Search location');
    //           setSubmitLoading(true);
    //    return;
    // }
    
    // Email Validation (basic regex)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(inputs.email)) {
      toast.error("Please enter a valid email address");
      setSubmitLoading(true);
      return;
    }

    // DOB Validation (age 18+)
    let dob = new Date(inputs.DOB);
    let today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    let m = today.getMonth() - dob.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    if (age < 18) {
      toast.error("You must be at least 18 years old");
      setSubmitLoading(true);
      return;
    }

    console.log("mydata", inputs);

   const  finaldata = {
        ...inputs,
//      address : form.address,
// longitude: form.longitude,
// latitude: form.latitude
       location: filterInputs?.location || "",
      lat: filterInputs?.lat || "",
       lng: filterInputs?.lng || "",
       features: featuresData,
       faqs: faqData,
       offers: offersData,
       images: inputValues,
   }
    try {
      const { data } = await axiosInstance.put(
        `/update-user-type/${id}`,
        finaldata,
           {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { success } = data;
      if (success) {
        toast.success("Account Created Successfully  ");
        // setTimeout(() => {
        //   window.location.href = adminurl;
        // }, 1000);
      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
      setSubmitLoading(true);

    } finally {
      setSubmitLoading(true);
    }

    setSubmitLoading(true);
  };


  
  const fetchUser = async () => {
    setLoading(true);
    console.log("response.data start");
    const decryptdatajson = getDecryptData();
     const mid = decryptdatajson?._id;
    let myid = id ?? mid ; 
    
    try {
      const response = await axiosInstance.get(`/get-user?userId=${myid}`);
      console.log("response.data.existingUser,", response.data.existingUser);
 
      const {existingUser, success} = response.data;
 
           if(success){
            setInputs((prevData) => ({
          ...prevData,
          username: existingUser.username || "",
          phone: existingUser.phone || "",
          email: existingUser.email || "",
          address: existingUser.address || "",
          pincode: existingUser.pincode || "",
          state: existingUser.state || "",
          statename: existingUser.statename || "",
          country: existingUser.country || "",
          city: existingUser.city || "",
          about: existingUser.about || "",
          department: existingUser.department || "", 
          gender: existingUser.gender || "", 
          DOB: existingUser.DOB || "", 
          subDepartments: existingUser.subDepartments || "", 
          profile: existingUser.profile || "",
          Doc1: existingUser.Doc1 || "",
          Doc2: existingUser.Doc2 || "",
          Doc3: existingUser.Doc3 || "",
          Doc4: existingUser.Doc4 || "",
          Doc5: existingUser.Doc5 || "",
          Doc6: existingUser.Doc6 || "",
          Doc7: existingUser.Doc7 || "",
          Doc8: existingUser.Doc8 || "",
          Doc9: existingUser.Doc9 || "",
          Doc10: existingUser.Doc10 || "",
           images: existingUser.images || [],
          features: existingUser.features || '',
           faqs: existingUser.faqs || '',
          offers: existingUser.offers || [],
          type:  existingUser.type,
          location:  existingUser.location,
          about:   existingUser.about,
        }));
 
        setFeaturesData(existingUser.features || []);
        setFaqData(existingUser.faqs || []);
        setOffersData(existingUser.offers || []);

           }
       


    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones-department");
      console.log("response.data.Zones,", response.data.Zones);
      setDataNew(response.data.Department ?? [])
      setData(response.data.Zones ?? []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const UpdateDoc = async ()=> {

       const decryptdatajson = getDecryptData();
     const mid = decryptdatajson?._id;
    let myid = id ?? mid ; 
     
      setLoading(true);
    console.log("response.data start", inputs );

     const finaldata ={
        ...inputs,
        id: myid
   }

    try { 
   const { response } = await axiosInstance.post(
        `/complete-profile/10`,
        finaldata,
           {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log('responseresponse',response)
      const {success} = response.data;
      if(success){
        
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    fetchUser();
  }, [id]);


  


  //   useEffect(() => {
  //    setInputs((prevData) => ({
  //     ...prevData,
  //     empType: null,
  //   }));
  // }, [inputs.type]);


  


  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  // mym map logic 

   const mapRef = useRef(null);
  const markerRef = useRef(null);
  const geocoderRef = useRef(null);
  const autocompleteRef = useRef(null);
  const searchInputRef = useRef(null);

  const [loadingMaps, setLoadingMaps] = useState(true);
  const [placeId, setPlaceId] = useState("");
  const [form, setForm] = useState({
    address: "",
    latitude: "",
    longitude: "",
  });

  const toFixed6 = (n) => Number(n).toFixed(6);

  // --- load Google Maps script dynamically ---
//   useEffect(() => {
  
//  initMap()
//   }, []);

useEffect(() => {
  const interval = setInterval(() => {
    if (window.google && mapRef.current) {
      initMap();
      clearInterval(interval);
    }
  }, 100);
  return () => clearInterval(interval);
}, []);


  // --- init map ---
  function initMap() {
    // Fallback center: New Delhi
    const start = { lat: 28.6139, lng: 77.2090 };

    const map = new window.google.maps.Map(mapRef.current, {
      center: start,
      zoom: 13,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: true,
    });

    const marker = new window.google.maps.Marker({
      position: start,
      map,
      draggable: true,
      animation: window.google.maps.Animation.DROP,
    });

    const geocoder = new window.google.maps.Geocoder();

    // Click on map = move marker + reverse geocode
    map.addListener("click", (e) => updatePosition(e.latLng));

    // Drag marker end = reverse geocode
    marker.addListener("dragend", (e) => updatePosition(e.latLng));

    // Places Autocomplete
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
      {
        fields: ["place_id", "formatted_address", "geometry", "address_components"],
        // componentRestrictions: { country: ["in"] }, // <- uncomment to restrict to India
      }
    );
    autocomplete.bindTo("bounds", map);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        toast("No details for that selection.");
        return;
      }
      setPlaceId(place.place_id || "");
      updatePosition(place.geometry.location, place.formatted_address);
    });

    function updatePosition(latLng, presetAddress) {
      map.panTo(latLng);
      marker.setPosition(latLng);

      const lat = toFixed6(latLng.lat());
      const lng = toFixed6(latLng.lng());

      setForm((f) => ({ ...f, latitude: lat, longitude: lng }));

      if (presetAddress) {
        setForm((f) => ({ ...f, address: presetAddress }));
      } else {
        geocoder.geocode({ location: latLng }, (res, status) => {
          if (status === "OK" && res && res[0]) {
            setForm((f) => ({ ...f, address: res[0].formatted_address || "" }));
            setPlaceId((pid) => pid || res[0].place_id || "");
          } else {
            setForm((f) => ({ ...f, address: "" }));
          }
        });
      }
    }

    // Expose in refs
    markerRef.current = marker;
    geocoderRef.current = geocoder;
    autocompleteRef.current = autocomplete;
 
    setLoadingMaps(false);
  }

  function geolocate() {
    if (!navigator.geolocation) {
      toast("Geolocation not supported.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const latLng = new window.google.maps.LatLng(latitude, longitude);
        setPlaceId("");
        // Reuse same flow as init
        const map = markerRef.current.getMap();
        map.panTo(latLng);
        markerRef.current.setPosition(latLng);
        reverseGeocode(latLng);
        setForm((f) => ({ ...f, latitude: toFixed6(latitude), longitude: toFixed6(longitude) }));
        toast.success("Centered to your location.");
      },
      () => toast.error("Permission denied or unavailable."),
      { enableHighAccuracy: true, timeout: 8000 }
    );
  }

  function reverseGeocode(latLng) {
    geocoderRef.current.geocode({ location: latLng }, (res, status) => {
      if (status === "OK" && res && res[0]) {
        setForm((f) => ({ ...f, address: res[0].formatted_address || "" }));
      }
    });
  }

  function onChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

 
  function clearAll() {
    setForm({ address: "", latitude: "", longitude: "" });
    setPlaceId("");
    toast.success("Cleared fields (map unchanged).");
  }

  // function toast(msg) {
  //   // Simple Bootstrap toast substitute
  //   const el = document.createElement("div");
  //   el.className = "position-fixed bottom-0 end-0 p-3";
  //   el.style.zIndex = 1080;
  //   el.innerHTML = `
  //     <div class="toast align-items-center text-bg-dark border-0 show" role="alert">
  //       <div class="d-flex">
  //         <div class="toast-body">${msg}</div>
  //         <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
  //       </div>
  //     </div>`;
  //   document.body.appendChild(el);
  //   setTimeout(() => el.remove(), 2200);
  // }

    const selectedSubDepartments = inputs.department
  ? data2
      .filter((item) => inputs.department.includes(item._id) && item.value)
      .flatMap((item) =>
        item.value.map((sub) => ({
          parent: item.name,
          value: sub,
          label: `${item.name} → ${sub}`
        }))
      )
  : [];


  const handleLocationChange = (selected) => {
  console.log('selectedselectedselected',selected)
  setFilterInputs({
    location: selected?.label || "",
    placeId: selected?.value || "",
    lat: selected?.lat || "",
    lng: selected?.lng || "",

  });
};

const docKeys = [
  "Doc1","Doc2","Doc3","Doc4","Doc5",
  "Doc6","Doc7","Doc8","Doc9","Doc10"
];

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />


        <div className="container pt-0">
          <h4> Update User  </h4>
          <hr/>
          <div
            className="dashboard-content bg-white px-4 py-3 "
            style={{ maxWidth: "100vw" }}
          >
            {loading ?  <LoadingScreen/>
            : <div className="card  border-0">
              <div className="m-b20 row"> 
                
                <div className="mb-4">
                  <label className="form-label text-dark" htmlFor="name">
                  {inputs.type === 3 ? 'Brand Name' : ' Full Name' }  <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      name="username"
                      value={inputs.username}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-4 col-6">
                  <label className="form-label text-dark" htmlFor="name">
                    Phone <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="number"
                      id="phone"
                      className="form-control"
                      name="phone"
                      value={inputs.phone}
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          // Check input length before updating
                          handleChange(e); // Call handleChange if length is within limit
                        }
                      }}
                      onInput={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 10) {
                          setInputs({ ...inputs, phone: inputValue });
                        }
                      }}
                      // onChange={() => {
                      //   handleChange();
                      // }}
                    />
                  </div>
                </div>
                <div className="mb-4 col-6">
                  <label className="form-label text-dark" htmlFor="email">
                    Email <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      name="email"
                      value={inputs.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="password">
                    Password <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control dz-password"
                      name="password"
                      value={inputs.password}
                      onChange={handleChange} // Add onChange handler to manage input changes
                      // onKeyPress={(e) => {
                      //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                      //     submitLoginPass();
                      //   }
                      // }}
                    />
                    <span className="input-group-text text-primary p-1">
                      {/* Toggle password visibility button */}
                      <i
                        className={
                          showPassword
                            ? "ri-eye-off-fill cursor"
                            : "ri-eye-fill cursor"
                        }
                        onClick={togglePasswordVisibility}
                      />
                    </span>
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="password">
                    Confirm Password{" "}
                    <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control dz-password"
                      name="confirm_password"
                      value={inputs.confirm_password}
                      onChange={handleChange} // Add onChange handler to manage input changes
                      // onKeyPress={(e) => {
                      //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                      //     submitLoginPass();
                      //   }
                      // }}
                    />
                    <span className="input-group-text text-primary p-1">
                      {/* Toggle password visibility button */}
                      <i
                        className={
                          showPassword
                            ? "ri-eye-off-fill cursor"
                            : "ri-eye-fill cursor"
                        }
                        onClick={togglePasswordVisibility}
                      />
                    </span>
                  </div>
                </div>

  {inputs.type !== 3 && <>
                  <div className="mb-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={inputs.gender}
                        name="gender"
                        onChange={handleChange}
                      >
                        <option selected disabled>
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>
           

                  <div className="mb-4 col-6  ">
                    <label className="form-label text-dark" htmlFor="email">
                      DOB <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                  
                      <input
                        type="date"
                        id="DOB"
                        className="form-control custom-date"
                        name="DOB"
                        value={inputs.DOB}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
           
 </>}

                <div className="mb-4 col-md-4  ">
                  <label className="form-label text-dark" htmlFor="email">
                    State <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="state"
                      name="state"
                      value={inputs.state}
                      onChange={handleChange}
                    >
                      <option selected disabled>
                        {" "}
                        {loading ? "Loading..." : "Select State"}
                      </option>
                      {data.length !== 0 && data.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>


                <div className="mb-4 col-md-4  ">
                  <label className="form-label text-dark" htmlFor="city">
                    City <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="city"
                      name="city"
                      value={inputs.city}
                      onChange={handleChange}
                    >

                      { filteredCities.length === 0 &&
                       <option selected value={""} >
                      {inputs.city}
                      </option> 
                      }
                        

                      <option   value={""} disabled>
                        {" "}
                     Select City 
                      </option>
                      {Array.isArray(filteredCities) && filteredCities.length > 0 && (
  filteredCities.map((city, index) => (
    <option key={index} value={city}>
      {city}
    </option>
  ))
)}

                    </select>
                  </div>
                </div>

                {/* <div className="mb-4 col-md-4  ">
         
 <div className="mb-2 col-12">
     <label className="form-label text-dark" htmlFor="coverage">
       Coverage Areas <span className="text-muted">(Multi Select)</span>
     </label>
     <div className="input-group input-sm">
       <select
         className="form-control"
         id="coverage"
         name="coverage"
         onChange={handleChange}
         selected={inputs.coverage}
         value={'null'}
       >
         <option value="null" selected>
           Select Coverage Area
         </option>
         {filteredCities.map((city, index) => (
           <option key={index} value={city}>
             {city}
           </option>
         ))}
       </select>
     </div>
     </div>

     <div className="mb-4">
{Array.isArray(inputs.coverage) && inputs.coverage.length > 0 ? (
 inputs.coverage.map((city, index) => (
   <span
     key={index}
     className="badge bg-primary me-1"
     style={{ cursor: "pointer" }}
     onClick={() => removeCoverage(city)}
     title="Click to remove"
   >
     {city} ×
   </span>
 ))
) : (
 <span className="text-muted">No coverage cities selected.</span>
)}
</div>
</div> */}
                

                <div className="mb-4 col-md-4  ">
                  <label className="form-label text-dark" htmlFor="email">
                    Pincode <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="number"
                      id="pincode"
                      className="form-control custom-date"
                      name="pincode"
                      value={inputs.pincode}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                
                      
                         <div className="mb-4 col-12 ">
                                          <label className="form-label text-dark" htmlFor="department">
                                            Category{" "}
                                            <span className="text-danger"> ( Required )</span>
                                          </label>
                                          <div className="input-group    input-sm">
                                            
                                            <Select
                  isMulti
                  options={data2.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))} 
                  placeholder="Select Category"
                  className="w-100"
                  value={
                    inputs.department && Array.isArray(inputs.department)
                      ? inputs.department.map((id) => {
                          const dep = data2.find((item) => item._id === id);
                          return dep ? { value: dep._id, label: dep.name } : null;
                        }).filter(Boolean)
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
                
                    // Update department selection
                    handleChange({
                      target: {
                        name: "department",
                        value: selectedIds,
                      },
                    });
                
                    // Reset sub departments when department changes
                    handleChange({
                      target: {
                        name: "subDepartments",
                        value: [],
                      },
                    });
                  }}
                />
                
                                            
                                          </div>
                                        </div>
                 
                   
                
                {selectedSubDepartments.length > 0 && (
                  
                        <div className="mb-4 col-12 "> 
                         <label className="form-label text-dark" htmlFor="subDepartments">
                                           Sub Category{" "}
                                            <span className="text-danger"> ( Required )</span>
                                          </label>
                  <Select
                    isMulti
                    placeholder="Select Sub-Category"
                    className="w-100 mt-3"
                    options={selectedSubDepartments}
                    value={
                      inputs.subDepartments?.map((sub) => {
                        const found = selectedSubDepartments.find((item) => item.value === sub);
                        return found ? { value: found.value, label: found.label } : null;
                      }).filter(Boolean) || []
                    }
                    onChange={(selectedOptions) => {
                      handleChange({
                        target: {
                          name: "subDepartments",
                          value: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
                        },
                      });
                    }}
                  />
                           </div>
                )}
                 
                        <div className="mb-4 col-12  ">
                                          <label className="form-label text-dark" htmlFor="email">
                                 {inputs.location ? 'Change Location': 'Choose Location ' }
                                  <span className="text-danger"> ( Required )</span>
                               
                                           </label>
                                           {inputs.location &&  <p className="small"> <span className="text-success"> Current :</span> {inputs.location} </p> }
                                          <div className="input-group    input-sm">
                                           
                <GooglePlaceSelect
                  value={
                    filterInputs.placeId
                      ? { label: filterInputs.location, value: filterInputs.placeId , lat : filterInputs.lat,
                              lng : filterInputs.lng }
                      : null
                  }
                  onChange={handleLocationChange}
                />
                                          </div>
                   </div>
                
                
                
                
                                      <div className="mb-4 col-12  ">
                                        <label className="form-label text-dark" htmlFor="email">
                                         Full Address
                                          <span className="text-danger"> ( Required )</span>
                                        </label>
                                        <div className="input-group    input-sm">
                                          <textarea
                                            id="pincode"
                                            className="form-control custom-date"
                                            name="address"
                                            value={inputs.address}
                                            onChange={handleChange}
                                          />
                                        </div>
                                      </div>
                

                     <div className="mb-4 col-6 col-md-3">
                                                                <label className="form-label text-dark" htmlFor="profileImage">
                                                                 {inputs.type === 3 ? 'Brand' : 'Profile'}  Image
                                                                  <span className="text-danger"> ( Required )</span>
                                                                </label>
                                      
                                                                <div className="openimage-container">
                                        {inputs.profile && typeof inputs.profile === "string" ? (
                                          <img
                                            src={inputs.profile !== "" ? weburl + inputs.profile : "/img/profile-default.png"}
                                            id="ProfileImage"
                                            alt="Profile Image"
                                            style={{
                                              width: "100%",
                                              aspectRatio: "1/1",
                                              background: "#f8f9fa",
                                              display: "block",
                                              textAlign: "center",
                                              lineHeight: "40vh",
                                              borderRadius: "",
                                              objectFit: "cover",
                                              border: "1px solid grey",
                                            }}
                                          />
                                        ) : (
                                          <img
                                            src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" 
                                              ? weburl + inputs.profile 
                                              : "/img/profile-default.png"}
                                            id="ProfileImage"
                                            alt="Profile Image"
                                            style={{
                                              width: "100%",
                                              aspectRatio: "1/1",
                                              background: "#f8f9fa",
                                              display: "block",
                                              textAlign: "center",
                                              lineHeight: "40vh",
                                              borderRadius: "",
                                              objectFit: "cover",
                                              border: "1px solid grey",
                                            }}
                                          />
                                        )}
                                        <input
                                          type="file"
                                          id="profileImage"
                                          className="form-control"
                                          name="profileImage"
                                          accept=".jpg, .jpeg, .png, .webp"
                                          onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (file) {
                                              const reader = new FileReader();
                                              reader.onload = (e) => {
                                                const imgElement = document.getElementById("ProfileImage");
                                                if (imgElement) {
                                                  imgElement.src = e.target.result; // Set the image URL directly on the img element
                                                }
                                              };
                                              reader.readAsDataURL(file); // Read the file as a data URL
                                              setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
                                            }
                                          }}
                                        />
                                      </div>
                                      
                                                              </div>
                                    

                                    {docKeys.map((docKey, index) => (
                                        <div className="mb-4 col-6 col-md-3">
                                                                <label className="form-label text-dark" htmlFor="profileImage">
                                                                  {docKey}
                                                                  <span className="text-danger"> ( Required )</span>
                                                                </label>

  <div className="openimage-container" key={docKey}>
    <img
   
      src={
        inputs[docKey] && typeof inputs[docKey] === "string"
          ? weburl + inputs[docKey]
          : "/img/profile-default.png"
      }
      id={`ProfileImage-${docKey}`}
      alt={`${docKey} Image`}
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />

    <input
      type="file"
      className="form-control"
      accept=".jpg, .jpeg, .png, .webp"
      onChange={(event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById(`ProfileImage-${docKey}`);
          if (img) img.src = e.target.result;
        };
        reader.readAsDataURL(file);

        setInputs((prev) => ({
          ...prev,
          [docKey]: file,
        }));
      }}
    />
  </div>
    </div>
))}

<button type='button' onClick={UpdateDoc} >
  Update Image
</button>
                                
                                      <div className="mb-4 col-12">
                                                          <label className="form-label text-dark" htmlFor="email">
                                                            About
                                                            <span className="text-danger"> ( Required )</span>
                                                          </label>
                                
                                                          <ReactQuill
                                                            value={inputs.about}
                                                            onChange={handleDescriptionChange}
                                                            modules={{
                                                              toolbar: [
                                                                [
                                                                  "bold",
                                                                  "italic",
                                                                  "underline",
                                                                  "strike",
                                                                  "blockquote",
                                                                ],
                                                                [{ list: "ordered" }, { list: "bullet" }],
                                                              ],
                                                            }}
                                                            formats={[
                                                              "bold",
                                                              "italic",
                                                              "underline",
                                                              "strike",
                                                              "blockquote",
                                                              "list",
                                                              "bullet",
                                                            ]}
                                                            bounds={".app"}
                                                          />
                                                        </div>
                
{inputs.type === 3 && <>


<div className="bg-light p-3 border mb-3 rounded">

<h5 className='mb-2'> Offer Section - </h5>
<hr/>

  <OfferSection
        initialData={offersData}
        onChange={(data) => setOffersData(data)}
       />
  
</div>

<hr/>
 
<div className="bg-light p-3 border mb-3 rounded">

<h5 className='mb-2'> Gallery Section - </h5>
<hr/>

      <div className="col-md-12">
                          <button
                            onClick={addImageDiv}
                            className="btn btn-secondary btn-sm mb-3"
                            type="button"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="mx-1"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#1f2937"
                              stroke-width="1.5"
                              stroke-linecap="square"
                              stroke-linejoin="arcs"
                            >
                              <rect x="3" y="3" width="18" height="18" rx="2" />
                              <circle cx="8.5" cy="8.5" r="1.5" />
                              <path d="M20.4 14.5L16 10 4 20" />
                            </svg>
                            Add Image ( 1000px X 1000px )

                          </button>
                          <div id="imageContainer" className="row">


{inputs.images.map((image, index) => (
                                      <div
                                        className="col-md-3 col-6"
                                        key={index}
                                      >
                                        <div
                                          className={`input-group imageupload-bx mb-3`}
                                        >
                                          <img
                                            className="image-preview"
                                            src={image}
                                            alt="Preview"
                                            id={`imageinputN${index + 1}`}
                                            data-bs-toggle="modal"
                                            data-bs-target="#modal-default"
                                          />
                                          <input
                                            type="hidden"
                                            className="form-control imageopen"
                                            id={`imageproductN${index + 1}`}
                                            name="productImg[]"
                                            value={image}
                                          />
                                        </div>
                                        <button
                                          className="btn btn-danger d-block m-auto"
                                          onClick={removeImageDiv}
                                        >
                                          Delete
                                        </button>
                                        <br />
                                      </div>
                                    ))}


                            {imageDivs.map((imageDiv, index) => (
                              <React.Fragment key={index}>
                                {imageDiv}
                              </React.Fragment>
                            ))}
                          </div>

                              <Gallery />

                        </div>
</div>

<div className="bg-light p-3 border mb-3 rounded">
 
  <KeyFeatures
        initialData={featuresData}
        onChange={(data) => setFeaturesData(data)}
        mytext={'Amenities'}
      />
</div>

<div className="bg-light p-3 border mb-3 rounded">
 
  <FAQSection
        initialData={faqData}
        onChange={(data) => setFaqData(data)} 
      />
</div>


</> }




                  <div className="card shadow-sm d-none">
        <div className="row g-0">
          <div className="col-lg-4 p-2">
            <div
              ref={mapRef}
              style={{ width: "100%", height: 300, borderRadius: 8, background: "#f3f4f6" }}
            />
            {loadingMaps && (
              <div className="text-center py-3 small text-muted">Loading Google Maps…</div>
            )}
          </div>

          <div className="col-lg-8 p-3">
            <div className="mb-3">
              <label className="form-label">Search location</label>
              <div className="d-flex gap-2">
                <input
                  ref={searchInputRef}
                  type="text"
                  className="form-control"
                  placeholder="Type to search…"
                />
                <button onClick={geolocate} className="btn btn-primary" type="button">
                  Use my location
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Selected address</label>
              <textarea
                name="address"
                value={form.address}
                onChange={onChange}
                type="text"
                className="form-control"
                placeholder="Will auto-fill from pin/selection"
              />
            </div>

            <div className="row g-2 ">
              <div className="col-md-4">
                <label className="form-label">Latitude</label>
                <input
                  name="latitude"
                  value={form.latitude}
                  onChange={onChange}
                  type="text"
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Longitude</label>
                <input
                  name="longitude"
                  value={form.longitude}
                  onChange={onChange}
                  type="text"
                  className="form-control"
                  readOnly
                />
              </div>
           
            </div>

            <div className="d-flex gap-2 mt-3">
              {/* <button onClick={save} className="btn btn-primary" type="button">
                Save Location
              </button> */}
              <button onClick={clearAll} className="btn btn-danger" type="button">
                Clear
              </button>
            </div>

            <p className="form-text mt-3">
              • Click the map or drag the pin to set the location. <br />
              • Autocomplete search will center and fill the address. <br />
              
            </p>
          </div>
        </div>

        <div className="card-footer small text-muted d-flex justify-content-between">
          <span>Starts in New Delhi if geolocation is blocked.</span>
          <span>Restrict your API key to your domain.</span>
        </div>
      </div>


                {/* <div className="mb-4  ">
                  <label className="form-label text-dark" htmlFor="email">
                    Address <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <textarea
                      className="form-control"
                      id="address"
                      name="address"
                      onChange={handleChange}
                      rows="2"
                    >
                      {inputs.address}
                    </textarea>
                  </div>
                </div> */}

                <div className="w-auto me-auto mt-4">
                  {SubmitLoading ? (
                    <button
                      className="btn btn-thin btn-md w-100 btn-primary rounded-xl"
                      type="button"
                      onClick={handleSubmit}
                    >
               Update User
                     </button>
                  ) : (
                    <button
                      disabled
                      className="bbtn btn-thin btn-md w-100 btn-primary rounded-xl"
                      type="button"
                    >
                      <span className="ms-1">Loading...</span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </button>
                  )}
                </div>
              </div>
            </div>
            }
            
          </div>
        </div>
      </main>
 
    </>
  );
};

export default ProfileEdit;
